import { render, staticRenderFns } from "./ClassDetailCard.vue?vue&type=template&id=0020b8ee&scoped=true&"
import script from "./ClassDetailCard.vue?vue&type=script&lang=js&"
export * from "./ClassDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./ClassDetailCard.vue?vue&type=style&index=0&id=0020b8ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0020b8ee",
  null
  
)

export default component.exports